module.exports = __webpack_public_path__ + "img/laboCiel.2439ec60.svg";